import "./sentiment.css";
import React from 'react';

const getFngLabel = (classification, t) => {
  const map = {
    'Extreme Fear': t('home.sentimentFngExtremeFear'),
    'Fear': t('home.sentimentFngFear'),
    'Neutral': t('home.sentimentFngNeutral'),
    'Greed': t('home.sentimentFngGreed'),
    'Extreme Greed': t('home.sentimentFngExtremeGreed'),
  };
  return map[classification] || classification;
};

const getFngColor = (val) => {
  if (val <= 25) return '#ef4444';
  if (val <= 45) return '#f97316';
  if (val <= 55) return '#eab308';
  if (val <= 75) return '#84cc16';
  return '#22c55e';
};

const formatMcap = (v) => {
  if (!v) return '—';
  if (v >= 1e12) return `$${(v / 1e12).toFixed(2)}T`;
  if (v >= 1e9) return `$${(v / 1e9).toFixed(1)}B`;
  return `$${v.toLocaleString()}`;
};

const SentimentPanel = ({ sentiment, sentimentLoading, lang, t }) => (
  <div className="hp-sentiment-panel">
    <div className="hp-sentiment-panel-title">{t('home.sentimentTitle')}</div>
    <div className="hp-sentiment-grid">
      {/* F&G 指数卡片 */}
      <div className="hp-sentiment-card hp-sentiment-fng">
        <div className="hp-sentiment-fng-header">
          <span className="hp-sentiment-fng-label">{t('home.sentimentFng')}</span>
          {sentiment?.fngTimestamp && (
            <span className="hp-sentiment-updated">
              {t('home.sentimentUpdated')} {sentiment.fngTimestamp.toLocaleDateString(lang === 'zh' ? 'zh-CN' : 'en-US', { month: 'short', day: 'numeric' })}
            </span>
          )}
        </div>
        {sentimentLoading ? (
          <div className="hp-sentiment-loading">{t('home.sentimentLoading')}</div>
        ) : sentiment?.fngValue != null ? (
          <div className="hp-sentiment-fng-body">
            <div className="hp-sentiment-gauge">
              <svg viewBox="0 0 200 120" className="hp-sentiment-gauge-svg">
                <defs>
                  <linearGradient id="gauge-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#ef4444" />
                    <stop offset="25%" stopColor="#f97316" />
                    <stop offset="50%" stopColor="#eab308" />
                    <stop offset="75%" stopColor="#84cc16" />
                    <stop offset="100%" stopColor="#22c55e" />
                  </linearGradient>
                </defs>
                <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="var(--border-default)" strokeWidth="12" strokeLinecap="round" />
                <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="url(#gauge-grad)" strokeWidth="12" strokeLinecap="round" strokeDasharray="251.2" strokeDashoffset="0" />
                {(() => {
                  const angle = Math.PI - (sentiment.fngValue / 100) * Math.PI;
                  const cx = 100 + 80 * Math.cos(angle);
                  const cy = 100 - 80 * Math.sin(angle);
                  return <circle cx={cx} cy={cy} r="8" fill={getFngColor(sentiment.fngValue)} stroke="var(--bg-card)" strokeWidth="3" />;
                })()}
              </svg>
              <div className="hp-sentiment-fng-value" style={{ color: getFngColor(sentiment.fngValue) }}>
                {sentiment.fngValue}
              </div>
            </div>
            <div className="hp-sentiment-fng-class" style={{ color: getFngColor(sentiment.fngValue) }}>
              {getFngLabel(sentiment.fngClassification, t)}
            </div>
          </div>
        ) : (
          <div className="hp-sentiment-error">{t('home.sentimentError')}</div>
        )}
      </div>

      {/* BTC 占比 */}
      <div className="hp-sentiment-card">
        <span className="hp-sentiment-card-label">{t('home.sentimentBtcDominance')}</span>
        {sentimentLoading ? (
          <div className="hp-sentiment-loading">{t('home.sentimentLoading')}</div>
        ) : sentiment?.btcDominance != null ? (
          <>
            <div className="hp-sentiment-big-val">{sentiment.btcDominance.toFixed(1)}%</div>
            <div className="hp-sentiment-bar-track">
              <div className="hp-sentiment-bar-fill" style={{ width: `${sentiment.btcDominance}%` }} />
            </div>
          </>
        ) : (
          <div className="hp-sentiment-error">{t('home.sentimentError')}</div>
        )}
      </div>

      {/* 总市值 */}
      <div className="hp-sentiment-card">
        <span className="hp-sentiment-card-label">{t('home.sentimentTotalMcap')}</span>
        {sentimentLoading ? (
          <div className="hp-sentiment-loading">{t('home.sentimentLoading')}</div>
        ) : sentiment?.totalMcap != null ? (
          <div className="hp-sentiment-big-val">{formatMcap(sentiment.totalMcap)}</div>
        ) : (
          <div className="hp-sentiment-error">{t('home.sentimentError')}</div>
        )}
      </div>
    </div>
  </div>
);

export { getFngLabel, getFngColor, formatMcap };
export default SentimentPanel;
